// If anyone feels lost here....
// https://docs.google.com/spreadsheets/d/1flrcDbTKD34OKRyz-tsuFpAYzqlxN0KiQBmTEJxEoyw/edit?gid=0#gid=0

export const productConfigUrl = new Map([
    [251124001, 'https://ng-mtn.stoptheclock.app'],
    [260526001, 'https://ng-mtn.stoptheclock.app'],
    [251124002, 'https://ng-mtn.quizhead2head.app'],
    [260526002, 'https://ng-mtn.quizhead2head.app'],
    [251202001, 'https://izeplaytv.fantasydribble.com'],
    [251202002, 'https://ng-airtel.stoptheclock.app/login'],
    [260526004, 'https://ng-airtel.stoptheclock.app/login'],
    [251202003, 'https://ng-airtel.quizhead2head.app/welcome'],
    [260526003, 'https://ng-airtel.quizhead2head.app/welcome'],
    [251208001, 'https://ng-airtel.blg.gg/guest'],
    [251208002, 'https://izeplaytv.fantasydribble.com'],
    [251208005, 'https://izeplay.fantasydribble.com'],
    [251211001, 'https://ng-mtn.blg.gg'],
    [251211002, 'https://izeplay.fantasydribble.com'],
    [251212001, 'https://mtn.how2ai.co'],
    [251212002, 'https://mtn.smartdr.org'],
])

export const productIdConfig = new Map([
    [251124001, 65],
    [260526001, 65],
    [251124002, 64],
    [260526002, 64],
    [251202001, 69],
    [251202002, 51],
    [260526004, 51],
    [251202003, 52],
    [260526003, 52],
    [251208001, 50],
    [251208002, 69],
    [251208005, 70],
    [251211001, 66],
    [251211002, 70],
    [251212001, 84],
    [251212002, 83],
])

export const serviceIdConfig = new Map([
    [251124001, 234102200008305],
    [260526001, 234102200008305],
    [251124002, 234102200008310],
    [260526002, 234102200008310],
    [251202001, 40195],
    [251202002, 40155],
    [260526004, 40155],
    [251202003, 40165],
    [260526003, 40165],
    [251208001, 40145],
    [251208002, 40195],
    [251208005, 234102200008303],
    [251211001, 234102200008312],
    [251211002, 234102200008303],
    [251212001, 23410220000050819],
    [251212002, 23410220000050821],
])
